import  Axios  from "axios";
import{
    SET_PROPOSAL_LEAD_ASSIGNED_LIST,
    UNSET_PROPOSAL_LEAD_ASSIGNED_LIST
} from "@/store/mutation-types";
import{  getSalesLeadAssigned, saveUpdateSalesLeadAssigned as saveUpdateSalesLeadAssignedApi, getSalesLeadAssignedById as getSalesLeadAssignedByIdApi } from "@/store/api";

// initial state
const state = {
    getSalesLeadAssigned: [],
}

const getters = {
    getSalesLeadAssigned(state) {
        return state.getSalesLeadAssigned;
    },
};

const mutations = {
    [SET_PROPOSAL_LEAD_ASSIGNED_LIST](state,data){
        state.getSalesLeadAssigned = data;
    },
    [UNSET_PROPOSAL_LEAD_ASSIGNED_LIST](state){
        state.getSalesLeadAssigned = [];
    }
};

const actions = {
    // saveUpdateSalesLeadAssigned({commit}, data){
    //     commit("SET_LOADING" , {color: "primary"});
    //     return new Promise((resolve , reject) => {
    //         Axios.post(saveUpdateSalesLeadAssigned , data)
    //         .then(function (response){
    //             resolve(response);
    //         })
    //         .catch(function (error){
    //             reject(error);
    //         })
    //         .then((always) => {
    //             commit ("UNSET_LOADING");
    //         });
    //     });
    // },

    saveUpdateSalesLeadAssigned({ commit }, { lead_id , ...data }) {
        const saveUpdateSalesLeadAssigned = `${saveUpdateSalesLeadAssignedApi}/${lead_id}`;
        commit("SET_LOADING", { color: "primary" });
    
        return new Promise((resolve, reject) => {
          Axios.post(saveUpdateSalesLeadAssigned , data)
            .then((response) => resolve(response))
            .catch((error) => reject(error))
            .finally(() => commit("UNSET_LOADING"));
        });
      },

    getSalesLeadAssigned({commit}, data){
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadAssigned, data)
            .then(function(response){
                commit('SET_PROPOSAL_LEAD_ASSIGNED_LIST', response.data.data)
                resolve(response);
            })
            .catch(function (error){
                commit('UNSET_PROPOSAL_LEAD_ASSIGNED_LIST')
                reject(error);
            })
            .then((always) =>{

            });
        });
    },

    getSalesLeadAssignedbyId({commit} , id){
        const getSalesLeadAssignedbyId = `${getSalesLeadAssignedByIdApi}/${id}`;
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.get(getSalesLeadAssignedbyId)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                reject(error);
            }).finally(() => {
                commit("UNSET_LOADING");
            })
        })
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}